import type { ReactElement } from "react";
import type { AircallZuordnungslauf } from "@kundeninfo/api-client";
import { Chip, Tabelle } from "@kundeninfo/ui/me-design";
import { formatZeitpunkt } from "../format.js";
import "./AircallZuordnungslaeufe.css";

/**
 * DIE ZUORDNUNG JE LAUF im Aircall-Dienst-Detail (Spec „Aircall: Vermittlungen", E322, E324, V13, V14, V17): die
 * letzten 14 Läufe, jüngster zuerst — ACW-Spannen des Exportfensters, über das Ende, über den Gesprächsbeginn
 * (Vermittlung), ohne Anruf (davon am Ende einer anderen Agentin), mehrdeutig, Quote. Eine Zeitreihe und deshalb
 * zeitlich sortiert, nicht „Schlechtestes oben": Den schlechtesten Zustand zeigen Zeile und Karte darüber; Läufe unter
 * der Grenze tragen den Chip „unter Grenze". Zahlen rechtsbündig. Block `acz`.
 */

/** Prozent mit Komma, ohne Wert „—" (Quote ohne Spannen, V13). */
export function prozent(q: number | null): string {
  return q === null ? "—" : `${String(q).replace(".", ",")} %`;
}

export function AircallZuordnungslaeufe(p: { laeufe: readonly AircallZuordnungslauf[]; mindestProzent: number }):
  ReactElement {
  return (
    <section className="acz" aria-label="Zuordnung je Lauf">
      <h3 className="acz__titel">Zuordnung je Lauf</h3>
      {p.laeufe.length === 0 ? (
        <p className="acz__leise">Noch kein Lauf mit Nacharbeitsschritt.</p>
      ) : (
        <Tabelle stapeln>
          <table className="acz__tabelle">
            <thead>
              <tr>
                <th scope="col">Lauf</th>
                <th scope="col" data-ausrichtung="rechts">ACW-Spannen</th>
                <th scope="col" data-ausrichtung="rechts">über Ende</th>
                <th scope="col" data-ausrichtung="rechts">über Beginn</th>
                <th scope="col" data-ausrichtung="rechts">ohne Anruf</th>
                <th scope="col" data-ausrichtung="rechts">davon fremdes Ende</th>
                <th scope="col" data-ausrichtung="rechts">mehrdeutig</th>
                <th scope="col" data-ausrichtung="rechts">Quote</th>
              </tr>
            </thead>
            <tbody>
              {p.laeufe.map((l) => (
                <tr key={l.laufAm}>
                  <td>{formatZeitpunkt(l.laufAm)}</td>
                  <td className="ki-num" data-ausrichtung="rechts">{l.acwSpannen}</td>
                  <td className="ki-num" data-ausrichtung="rechts">{l.ueberEnde}</td>
                  <td className="ki-num" data-ausrichtung="rechts">{l.ueberBeginn}</td>
                  <td className="ki-num" data-ausrichtung="rechts">{l.ohneKandidat}</td>
                  <td className="ki-num" data-ausrichtung="rechts">{l.fremdesEnde}</td>
                  <td className="ki-num" data-ausrichtung="rechts">{l.mehrdeutig}</td>
                  <td className="ki-num" data-ausrichtung="rechts">
                    {prozent(l.quoteProzent)}
                    {l.quoteProzent !== null && l.quoteProzent < p.mindestProzent && (
                      <Chip className="acz__marke" statusArt="warnung">unter Grenze</Chip>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Tabelle>
      )}
    </section>
  );
}
